import { Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useAuth } from "../../context/AuthContext";

interface ProtectedRouteProps {
    children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
    const { isAuthenticated } = useAuth();
    const [authChecked, setAuthChecked] = useState(false);

    useEffect(() => {
        const checkAuthentication = async () => {
            const token =
                localStorage.getItem("accessToken") ||
                sessionStorage.getItem("accessToken");

            if (token) {
                setAuthChecked(true);
            } else {
                setAuthChecked(true);
            }
        };

        checkAuthentication();
    }, []);

    if (!authChecked) {
        return (
            <div className="auth-loading">
                <div className="spinner"></div>
            </div>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    return <>{children}</>;
};

export default ProtectedRoute;
